import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";
import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "@/components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import EmployeeDirectoryPage from "@/modules/hub/features/EmployeeDirectory/pages/EmployeeDirectoryPage";
import ProfileDetailsPage from "@/modules/hub/features/EmployeeDirectory/pages/ProfileDetailsPage";

const EmployeeDirectoryMainLayout = () => (
  <MainLayout section="employee-directory" />
);

const EmployeeDirectoryRoutes = (
  <Route
    element={<AuthenticationGuard component={EmployeeDirectoryMainLayout} />}
    path="/employee-directory"
  >
    <Route
      element={
        <PermissionGuard requiredPermissions={["employee-directory"]}>
          <EmployeeDirectoryPage />
        </PermissionGuard>
      }
      index
    />
    <Route
      element={
        <PermissionGuard requiredPermissions={["employee-directory"]}>
          <ProfileDetailsPage />
        </PermissionGuard>
      }
      path=":uuid"
    />
  </Route>
);

export default EmployeeDirectoryRoutes;
